<template>
    <div class="alert alert-primary">
        <p><slot></slot></p>
    </div>

</template>

<script>
export default {
    name: "AlertBox"
}
</script>

<style lang="scss" scoped>
    .alert {
        color: white;
        background-color: $primary-color !important;
        border-color: transparent;
        border-radius: 5px;
    }

    .alert > p {
        color: white;
        padding: 0;
        margin: 0;
        line-height: 12px;
    }




</style>